import {BaseBlock, theme} from "../../framework/js/core";

export class ContactForm7 extends BaseBlock {
  
  constructor(root) {
    super(root);
    
    this.form = root.find(".wpcf7-form");
    this.originalResponse = this.form.find(".wpcf7-response-output");
    
    this._popupEnabled = true;
    this.popup = this.originalResponse.clone();
    this.popup.on("click", () => this.hidePopup());
    
    $(document.body).append(this.popup);
  
    // Moving status popup outside of form and bind closing event
    if (typeof MutationObserver !== "undefined") {
      // create an observer instance
      let popupObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === "childList") {
            this.showPopup(mutation.target.innerHTML);
            this.notify("responseMutation", mutation);
            this.originalResponse.hasClass("wpcf7-mail-sent-ok")
              ? this.notify("successfulRequest")
              : this.notify("failedRequest");
          }
        });
      });
  
      // pass in the target node, as well as the observer options
      popupObserver.observe(this.originalResponse.get(0), {
        attributes: true,
        childList: true,
        characterData: true
      });
      
      let requestObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === "attributes") {
            if ($(mutation.target).hasClass("is-active")) {
              this.showSpinner();
              this.notify("requestInProcess");
            } else {
              this.hideSpinner();
              this.notify("requestComplete");
            }
          }
        });
      });
      
      let ajaxLoaderEl = this.form.find(".ajax-loader").get(0)
      if (ajaxLoaderEl) {
        requestObserver.observe(ajaxLoaderEl, {
          attributes: true
        });
      }
    }
    
    
    // Applying elastic textarea snippet
    this.root.find("textarea").on("keyup", function() {
      $(this).textareaElastic();
    });
    
    // Applying classes for different states for further styling
    this.root.find("span.title").toArray().map(title => {
      return {
        title: $(title),
        field: $(title).siblings(".wpcf7-form-control-wrap").find("input, textarea")
      }
    }).filter(pair => {
      if (pair.title.hasClass("no-slide")) pair.title.addClass("focused");
      return pair.title.length && pair.field.length && !pair.title.hasClass("no-slide")
    }).map(pair => {
      pair.title.on("click", event => {
        pair.field.focus()
      });
      pair.field.on("focus", event => {
        pair.title.addClass("focused")
      });
      pair.field.on("blur", event => {
        if (!pair.field.val()) pair.title.removeClass("focused")
      });
    });
  }
  
  enablePopup() {
    $(document.body).append(this.popup);
    this._popupEnabled = true;
    return this;
  }
  
  disablePopup() {
    this.hidePopup();
    this.popup.detach();
    this._popupEnabled = false;
    return this;
  }
  
  showPopup(message) {
    if (!this._popupEnabled) return;
    this.popup
      .attr("class", this.originalResponse.attr("class"))
      .addClass("visible")
      .html(message);
    this.notify("popupShown");
    return this;
  }
  
  hidePopup() {
    this.popup.removeClass("visible");
    this.notify("popupHidden");
    return this;
  }
  
  showSpinner() {}
  
  hideSpinner() {}
}
